// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__mrsPS"};